import * as React from "react";

import { cn } from "@/lib/utils";
import { INPUT_HEIGHTS, BORDER_OPACITY, BORDER_RADIUS } from "./constants";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					"flex w-full border bg-[var(--color-bg-aqua-mist)] dark:bg-card px-3 py-2 text-xs text-foreground file:border-0 file:bg-transparent file:text-xs file:font-medium placeholder:text-[0.6875rem] placeholder:text-muted-foreground focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-50 flex-shrink-0",
					INPUT_HEIGHTS.base,
					BORDER_RADIUS.md,
					BORDER_OPACITY.standard,
					"focus:border-focus",
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
